import {Box, Button, Dialog, DialogContent, DialogTitle, Typography} from "@mui/material";
import React from "react";

export const createUserTypeSelectionDialog = ({showUserTypeDialog, setShowUserTypeDialog, setIsDeveloper, proceedToStripe}) => () => (
    <Dialog open={showUserTypeDialog} onClose={() => setShowUserTypeDialog(false)}>
        <DialogTitle>Account Type Selection</DialogTitle>
        <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
                To purchase credits without a subscription, please select your account type:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setIsDeveloper(true);
                        setShowUserTypeDialog(false);
                        proceedToStripe();
                    }}
                    sx={{ p: 2 }}
                >
                    <Box>
                        <Typography variant="h6">Developer</Typography>
                        <Typography variant="body2" color="text.secondary">
                            I'm purchasing credits for development/testing purposes
                        </Typography>
                    </Box>
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => {
                        window.location.href = '/subscriptions';
                    }}
                    sx={{ p: 2 }}
                >
                    <Box>
                        <Typography variant="h6">Business</Typography>
                        <Typography variant="body2" color="text.secondary">
                            I need credits for business use (requires subscription plan)
                        </Typography>
                    </Box>
                </Button>
            </Box>
        </DialogContent>
    </Dialog>
);